export default function ({ language }) {
  var config = {
    validators: ['mandatory'],
  };

  return {
    config,
    extendsType: 'text-field',
  };
}
